import React from "react";
import { Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Home from "./pages/Home";
import Services from "./pages/Services";
import Menu from "./pages/Menu";
import Contact from "./pages/Contact";

const App = () => {
  return (
    <>
      <Navbar />
      <Routes>
       <Route path="/" element={<Home />} />
<Route path="/menu" element={<Menu />} />
<Route path="/services" element={<Services />} />
<Route path="/contact" element={<Contact />} />

      </Routes>
    </>
  );
};

export default App;
